import React from 'react';

export const AppleIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.63 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

export const WindowsIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3 5.5L10.5 4.2v7.6H3V5.5zm0 8.1h7.5v7.6L3 19.9V13.6zm9.2-9.3L21 3.1v7.5h-8.8V4.3zm0 9.3H21v7.6l-8.8-1.5v-6.1z" />
  </svg>
);

export const LinuxIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.5 2c-1.1 0-2 .9-2 2 0 .5.2 1 .5 1.4-.6.3-1.1.7-1.5 1.2-1.1-.2-2.2.1-3 1-.9 1-1 2.5-.2 3.6-.8.6-1.3 1.5-1.3 2.5 0 1.8 1.5 3.3 3.3 3.3.3 0 .6 0 .9-.1.5 1.1 1.6 1.9 2.8 1.9 1.5 0 2.8-1.1 3.1-2.6 1.4-.3 2.4-1.5 2.4-3 0-.9-.4-1.7-1-2.3.5-1 .4-2.2-.3-3.1-.7-.9-1.9-1.4-3.1-1.2-.4-.5-.9-.9-1.5-1.2.3-.4.5-.9.5-1.4 0-1.1-.9-2-2-2zm-3 8.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm5 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z" />
  </svg>
);

export const PlayStoreIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M2.2 1.05 13.55 12 2.2 22.95A2.05 2.05 0 0 1 1 21.2V2.8c0-.8.47-1.52 1.2-1.75Z" />
    <path fill="#34A853" d="M13.55 12 2.2 22.95c.73.23 1.58.16 2.26-.23l10.2-5.8L13.55 12Z" />
    <path fill="#FBBC04" d="M20.95 13.4 14.66 17l-1.11-5 1.11-5 6.29 3.57c.9.51.9 1.75 0 2.26Z" />
    <path fill="#EA4335" d="M13.55 12 4.46 1.28A2.2 2.2 0 0 0 2.2 1.05L13.55 12Z" />
  </svg>
);

export const DownloadIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
  </svg>
);
